import { useEffect } from 'react';

/**
 * Oeffentliche Seiten (/, /start, /administration) scrollen ueber das
 * Dokument, nicht ueber <body>.
 *
 * Die App setzt html/body auf height:100% + overflow-y:auto (index.css,
 * Capacitor). Dann scrollt <body>, window.scrollY bleibt 0 — ScrollTrigger,
 * position:sticky am Fenster und die Scroll-Erkennung im Header laufen ins
 * Leere. Die beiden Klassen heben das nur fuer diese Seiten auf.
 */
const usePublicPageLayout = () => {
  useEffect(() => {
    document.body.classList.add('landing-page');
    document.documentElement.classList.add('landing-page-html');
    return () => {
      document.body.classList.remove('landing-page');
      document.documentElement.classList.remove('landing-page-html');
    };
  }, []);
};

export default usePublicPageLayout;
